import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, makeStyles } from '@material-ui/core';
const useStyles = makeStyles({
  tableContainer: {
    width: 'fit-content',
    border: '1px solid'
  },
  table: {
    minWidth: 400,
    width: 'fit-content'
  },
  cell: {
    padding: '2px 8px',
    fontSize: '0.875rem'
  },
  headerCell: {
    padding: '2px 4px',
    fontSize: '0.875rem',
    fontWeight: 600
  },
  rateCell: {
    textAlign: 'right'
  }
});
export const HCPCSTable = ({
  data
}) => {
  const classes = useStyles();
  const firstEl = data[0];
  let dataInUse = data;
  const doNotMatch = firstEl && firstEl.parentcode && firstEl.parentcode !== firstEl.code;

  if (doNotMatch) {
    dataInUse = data.reverse();
  } else {
    dataInUse = data;
  }

  const updatedData = dataInUse.reduce((seed, cell) => {
    const {
      code,
      rate,
      physicianservicediagnosis
    } = cell;
    let diagnosis = '';

    if (physicianservicediagnosis && physicianservicediagnosis.length) {
      const diagnosisArr = physicianservicediagnosis.map(x => x.icd10diagnosis);
      diagnosis = diagnosisArr.toString();
    }

    if (seed.length === 0) {
      seed.push(_objectSpread(_objectSpread({}, cell), {}, {
        count: 1,
        total: cell.rate,
        diagnosis
      }));
    } else {
      const hasDupIndex = seed.findIndex(x => x.code === code && x.rate === rate);

      if (hasDupIndex > -1) {
        seed[hasDupIndex] = _objectSpread(_objectSpread({}, seed[hasDupIndex]), {}, {
          count: seed[hasDupIndex].count + 1,
          total: seed[hasDupIndex].total + rate,
          diagnosis
        });
      } else {
        seed.push(_objectSpread(_objectSpread({}, cell), {}, {
          count: 1,
          total: cell.rate,
          diagnosis
        }));
      }
    }

    return seed;
  }, []);
  return /*#__PURE__*/React.createElement(TableContainer, {
    className: classes.tableContainer,
    component: Paper
  }, /*#__PURE__*/React.createElement(Table, {
    className: classes.table,
    size: "small"
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    className: classes.headerCell
  }, "Code"), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.headerCell
  }, "Description"), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.headerCell
  }, "Diagnosis"), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.headerCell
  }, "Count"), /*#__PURE__*/React.createElement(TableCell, {
    className: `${classes.headerCell} ${classes.rateCell}`
  }, "Rate"), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.headerCell
  }, "Total"))), /*#__PURE__*/React.createElement(TableBody, null, updatedData.map(row => {
    const rate = row.rate ? row.rate.toFixed(2) : 0;
    const total = row.total ? row.total.toFixed(2) : 0;
    return /*#__PURE__*/React.createElement(TableRow, {
      key: row.id,
      hover: true
    }, /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell
    }, row.code), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell
    }, row.description), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell
    }, row.diagnosis), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell
    }, row.count), /*#__PURE__*/React.createElement(TableCell, {
      className: `${classes.cell} ${classes.rateCell}`
    }, "$", rate), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell
    }, "$", total));
  }))));
};